<template>
  <div class="presenter-view-info-popup">
    <div class="box">
      <rp-sprite class="info-icon" name="info"/>
      <div class="text">
        <span class="title">
          Showing data based on all hospitals
        </span>
        <span class="description">
          zoom in to calculate based on visible area
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Sprite from 'raypro_ui/src/components/ui/Sprite'

export default {components: {'rp-sprite': Sprite}}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.presenter-view-info-popup
  display: flex
  justify-content: center

  .box
    padding: 8px 13px
    border-radius: 8px
    background-color: white
    box-shadow: 0 0 5px 0px $color-shadow
    display: flex
    align-items: center
    fill: $color-side-nav
    cursor: pointer

    .info-icon
      height: 30px
      width: 30px
      margin-right: 10px

    .text
      display: flex
      flex-direction: column

      .title
        font-size: 16px

      .description
        margin-top: 3px
        font-size: 12px

        
</style>



// WEBPACK FOOTER //
// src/components/PresenterViewInfoPopup.vue